import axios from 'axios'
import URL from 'url-parse'
import {isEmpty} from 'lodash'
import auth from './auth'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'
const API_NAMESPACE = process.env.REACT_APP_API_NAMESPACE || '/api/v1'
const BASEURL = `${API_URL}${API_NAMESPACE}`

// Create a configured axios instance
const server = axios.create({
  baseURL: BASEURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Authorization': auth.token()
  }
})

// Naive caching - more details below
let cache = {}

// Receives filters as an object and makes them JSONAPI-compliant
const adjustFilters = (filters = {}) => {
  if (isEmpty(filters)) return {}
  let adjustedFilters = {}
  for (let key in filters) {
    if (filters.hasOwnProperty(key)) {
      // If filter value is an array, stringify it first
      adjustedFilters[`filter[${key}]`] =
        (filters[key] instanceof Array) ?
        filters[key].join(',') :
        filters[key]
    }
  }
  return adjustedFilters
}


/*
* PUBLIC METHODS
*/

// All GETs are automatically cached
// Whenever any data is changed, the cache is destroyed (hence naive)
const get = (endpoint) => {
  return new Promise((resolve, reject) => {
    if (cache[endpoint]) {
      resolve(cache[endpoint])
    }
    else {
      server.get(endpoint)
      .then((result) => {
        cache[endpoint] = result
        resolve(result)
      })
      .catch((error) => reject(error))
    }
  })
}

// Collection GETs can receive multiple parameters:
// - filters: Object: JSON:API-style filters as key-value pairs
// - includes: Array: list of JSON:API relatioships to include
// - pageNumber/pageSize: Integer: pagination data
const getMany = (endpoint, filters, includes, pageNumber, pageSize) => {
  let url = new URL(`${BASEURL}${endpoint}`)
  let query = adjustFilters(filters)
  if (!isEmpty(includes)) query['include'] = includes.join(',')
  if (pageNumber) query['page[number]'] = pageNumber
  if (pageSize) query['page[size]'] = pageSize
  url.set('query', query)
  return get(url.toString())
}

// All functions below will empty the cache by default, unless otherwise noted

const post = (endpoint, data, keepCache = false) => {
  if (!keepCache) cache = {}
  return server.post(endpoint, data)
}

const put = (endpoint, data, keepCache = false) => {
  if (!keepCache) cache = {}
  return server.put(endpoint, data)
}

const patch = (endpoint, data, keepCache = false) => {
  if (!keepCache) cache = {}
  return server.patch(endpoint, data)
}

const del = (endpoint, keepCache = false) => { // delete is a reserved keyword
  if (!keepCache) cache = {}
  return server.delete(endpoint)
}


const api = {
  get: get,
  getMany: getMany,
  post: post,
  put: put,
  patch: patch,
  delete: del
}

export default api



// WEBPACK FOOTER //
// ./src/stores/jsonapi.js